import { useState } from 'react'
import { useMutation, useQuery } from 'react-query'
import { connect } from 'react-redux'
import graphQLRequest from 'CanExConfig/graphQLRequest'
import { FETCH_REMOTE_POLICIES, UPDATE_REMOTE_POLICIES } from '../../graphql/ProfileBuilding'
import {
  formatWorkplacePolicyForDefaultValues,
  formatWorkplacePolicyForSubmit,
  formatRestToGraphQL,
} from '../../../CandidateExperience/helpers/workplacePolicyHelpers'
import { currentState } from '../../selectors/sessions'
import { availableCountries, locationOsmStrings as getLocationOsmStrings } from '../../../Onboarding/redux/selectors/location'

const WorkplacePolicy = ({ candidateId, locationOsmStrings, children, ...rest }) => {
  const [editing, toggleEditing] = useState(false)
  const [workplacePolicySubmitError, setWorkplacePolicySubmitError] = useState()

  const {
    data: workplacePolicyData,
    status: workplacePolicyStatus,
    refetch: refetchWorkplacePolicy,
  } = useQuery(['workplacePolicies', candidateId], () => graphQLRequest(FETCH_REMOTE_POLICIES, { candidateProfileId: candidateId }), {
    refetchOnWindowFocus: false,
    initialData: [],
    select: data => (data && data.candidateProfile ? data.candidateProfile.remotePolicies : []),
  })

  const { mutate, isLoading: isSaving } = useMutation('updateRemotePolicies', props => graphQLRequest(UPDATE_REMOTE_POLICIES, props), {
    onSuccess: () => {
      refetchWorkplacePolicy()
      toggleEditing(false)
    },
    onError: () => {
      setWorkplacePolicySubmitError("We couldn't update location and remote preferences. Please refresh and try again.")
    },
  })

  const submitWorkplacePolicy = values => {
    const remotePolicies = formatRestToGraphQL(formatWorkplacePolicyForSubmit(values, locationOsmStrings))
    mutate({ input: { id: candidateId, remotePolicies } })
  }

  return children({
    loading: workplacePolicyStatus === 'loading',
    editing,
    toggleEditing: () => toggleEditing(!editing),
    isSaving,
    submitWorkplacePolicy,
    workplacePolicies: workplacePolicyData,
    workplacePolicySubmitError,
    defaultValues: formatWorkplacePolicyForDefaultValues(workplacePolicyData),
    locationOsmStrings,
    ...rest,
  })
}

function mapStateToProps(state) {
  return {
    availableCountries: availableCountries(state),
    locationOsmStrings: getLocationOsmStrings(state),
    currentState: currentState(state),
    enabledForCurrentState: !['live', 'ready_to_go_live', 'post_live'].includes(currentState(state)),
  }
}
export default connect(mapStateToProps, undefined)(WorkplacePolicy)
